export default async function getPruebas(addEstado, dispatch) {
  const url = "https://api.almeraim.com/securityairbytes/listbyinstance";

  const header = {
    "Cache-Control": "max-age=0",
  };

  try {
    const config = { method: "GET", headers: header };
    const response = await fetch(url, config);
    const json = await response.json();
    if (json.Count === 0) {
      dispatch(addEstado(true));
    } else {
      dispatch(addEstado(false));
    }
    return json;
  } catch (error) {
    console.log("Error" + error);
  }
}
